<template>
  <div>
    <div class="activeType" v-if="createStep == 1">
      <div class="top_container">
        <div class="img_box">
          <img
            class="img"
            src="@/assets/images/游戏封面.png"
            alt=""
          />
        </div>
        <div class="content_box">
          <div class="title">白条免息活动</div>
          <div class="content">
            <span>白条免息营销工具为商家提供自建活动，将店内商品创建白条交易分期免息活动。提高商家下单转化率和交易额。</span>
            <a class="url" href="#" @click="showExample = true">查看示例图></a>
            <a class="url" href="#" @click="showPDF">详细介绍></a>
          </div>
          <!-- <div class="tips_box tipBg">
            <div class="title">
              <img src="@/assets/images/new_icon_reminder.png" />
              <span>温馨提示：</span>
            </div>
            <p style="margin-top: 6px;">1.白条免息服务需判断商家准入条件，并非购买服务一定能进行白条免息活动创建。有如下2种情况可被拦截：</p>
            <p>(1)因合规/风险原因，白条交易不可使用商家，不允许创建白条营销活动：京喜拼拼、自然人商家、白条风险品类（虚拟/投资类等）等；</p>
            <p>(2)自营供应商需在签约货品购销活动时，需同时签署《白条促销服务协议》；未签署、合同审批中均不可以创建白条免息，需联系对应采销；</p>
            <p>2.白条免息服务协议签署，且配置了白条免息活动，商家需承担用户下单时减免的白条息费费用（息费费用=对应期数服务费率*白条支付金额）；该费用由白条侧从商家钱包扣除，或者世纪贸易代为扣除，明细账单可于京麦端或VC供应商系统查询。</p>
          </div> -->
          <div class="bottom_box">
            <button class="b1" @click="createIou">创建白条免息活动</button>
            <button class="b2" @click="openIouData">查看白条免息数据看板</button>
            <button class="b3" @click="openIouBill">查看白条费用账单</button>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="活动管理" name="first">
          <input-form ref="inputForm" :btnPosition1="true" :defaultSelectArr="true" :inputData="inputData" @toParentVal="searchForm"></input-form>
          <el-table
            :data="activityList"
            v-loading="talbeLoading"
            style="width: 100%; margin-top: 20px"
            ref="table"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
          <el-table-column label="活动编号" prop="refActId"></el-table-column>
          <el-table-column label="活动名称" prop="actBaseName"></el-table-column>
          <el-table-column label="商品参与方式" width="200px">
            <template slot-scope="scope">
              {{ scope.row.bound | boundFilter }}
            </template>
          </el-table-column>
          <el-table-column label="活动时间" width="380px">
            <template slot-scope="scope">
              {{ scope.row.startTime }}至{{ scope.row.finishTime }}
            </template>
          </el-table-column>
          <el-table-column label="活动状态" width="130px">
            <template slot-scope="scope">
              <span :class="`status${scope.row.baseStatus}`">{{ scope.row.baseStatus | baseStatusFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="参与人数" width="120" prop="joinNum">
          <template slot-scope="scope">
            {{scope.row.joinNum || 0}}
          </template>
        </el-table-column>
          <el-table-column width="180" label="操作">
            <template slot-scope="scope">
              <div class="editList">
                <span class="pointer" v-if="scope.row.baseStatus != 2 && scope.row.bound == 2" @click="addSku(scope.row)">添加sku</span>
                <span class="pointer" @click="detailFn(scope.row)">详情</span>
                <span class="pointer" style="color: #F56C6C;" v-if="scope.row.baseStatus != 2" @click="closeFn(scope.row)">关闭</span>
              </div>
            </template>
          </el-table-column>
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
          </el-table>

          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
    
    <!-- 创建活动 -->
    <template v-else>
      <create 
        :admittanceInfo="admittanceInfo"
        @returnBack="createStep = 1"
        @submit="submitFn"
      />
    </template>

    <!-- 详情 -->
    <el-dialog
      title="白条免息活动"
      :visible.sync="showDetail"
      width="460px"
      @close="showDetailClose"
    >
      <div class="activity_detail">
        <div class="title">查看白条免息活动</div>
        <div class="item">活动名称：{{ activityDetail.actBaseName }}</div>
        <div class="item">活动编号：{{ activityDetail.refActId }}</div>
        <div class="item">活动时间：{{ activityDetail.startTime }}-{{ activityDetail.finishTime }}</div>
        <div class="item">分期免息：{{ activityDetail.planNum | planNumFilter }}</div>
        <div class="item">参与方式：{{ activityDetail.bound | boundFilter }}</div>
        <div class="download" v-if="activityDetail.bound == 2 || activityDetail.bound == 3" @click="exportDetailSku(activityDetail)">批量导入商品：下载SKU文件</div>
        <div class="item" v-if="activityDetail.plusPlanNum">PLUS规则：{{ activityDetail.plusPlanNum | planNumFilter }}仅限PLUS用户专享</div>
        <div class="item">营销费用：店铺100%承担</div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="showDetail = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加sku -->
    <el-dialog
      title="添加sku"
      :visible.sync="dialogSKu"
      width="600px"
      class="sku_box"
      @close="closeAddSku"
    >
      <div>
        <el-upload
          ref="uploadFile"
          style="text-align: center;"
          class="upload-demo"
          drag
          action="/jd-hd-web/iou/checkSku"
          accept=".xls, .xlsx"
          :limit="1"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖拽到此处，或者<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip" style="line-height: 18px;">
            <button class="download" @click="downloadTemplate">下载模板</button>
            <div>只能上传EXCEL文件，且不能超过2M</div>
            <div>上传文件会自动去重已有的SKU</div>
          </div>
        </el-upload>
      </div>
      <span slot="footer">
        <div class="checkout" v-if="uploadData.total">
          校验成功<span class="success">{{ uploadData.passNo }}</span>个sku，校验失败<span class="error">{{ uploadData.noPassNo }}</span>个。<span class="dowload_error" v-if="Number(uploadData.noPassNo)" @click="uploadError">下载失败信息</span>
        </div>
        <el-button type="primary" @click="submitUpload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 关闭活动弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="showCloseActivity"
      width="420px"
    >
      <img
        src="@/assets/images/tips_icon.png"
        style="
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 4px 0 0 30px; font-size: 14px;"
        >是否确认关闭这项活动？关闭后，客户不再享受任何优惠。</span
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCloseActivity = false">取 消</el-button>
        <el-button type="primary" @click="submitClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 是否满足准入条件弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="isAdmittance"
      width="360px"
      :show-close="false"
    >
      <span style="line-height: 18px;">您好，很抱歉，您的店铺暂不支持此操作，给您带来不便，请谅解。详情请咨询京东官方。</span>
      <span slot="footer">
        <el-button type="primary" @click="isAdmittance = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 是否签署准入合同弹窗 -->
    <el-dialog
      :visible.sync="isSign"
      :width="venderType ? '450px' : '640px'"
      :show-close="false"
      class="isSign_box"
    >
      <!-- 自营标题 -->
      <div v-if="venderType" class="zy_header">
        请先签署《白条促销服务协议》后再创建活动
      </div>
      <!-- pop标题 -->
      <div v-else class="pop_header">
        白条免息活动签约
      </div>
      <div class="content_box">
        <!-- 自营 -->
        <template v-if="venderType">
          <div class="tips_text">您的店铺需签署《白条促销服务协议》并审批通过后才可以创建白条免息活动，<span style="font-weight: bold;">详情咨询对应采销</span></div>
        </template>
        <!-- POP -->
        <template v-else>
          <div class="tips_title">活动说明</div>
          <div class="tips_text">白条免息营销工具是京东白条为商家提供的营销工具。白条免息营销工具为商家提供自建活动，将店内商品创建白条交易分期免息活动，在活动有效期内，<span>活动商品将直接对用户免除使用白条分期所需支付的息费</span>，从而缩短用户交易决策时间，提高商家下单转化率和交易额。</div>
          <div class="tips_title">费用说明</div>
          <div class="tips_text"><span>商家需承担用户下单时减免的白条息费费用</span>（息费费用=对应期数服务费率*白条支付金额）；结算方式及扣款方式请查看活动协议说明，明细账单可于京麦端查询。</div>
          <div class="tips_title">活动协议</div>
          <div class="tips_text"><span class="font" @click="popAgreement">《白条促销服务协议》</span></div>
        </template>
      </div>
      <div v-if="venderType" style="text-align: right; padding: 20px;">
        <el-button type="primary" @click="goSign">我知道了</el-button>
      </div>
      <span v-else slot="footer" class="dialog-footer">
        <el-checkbox v-model="checked"></el-checkbox>
        <span class="custom_checkbox">我已阅读并同意《白条促销服务协议》内容。</span>
        <el-button @click="isSign = false">取 消</el-button>
        <el-button type="primary" @click="submitSign">确定签署</el-button>
      </span>
    </el-dialog>

    <!-- 查看示例图 -->
    <el-dialog
      :visible.sync="showExample"
      width="1000px"
      class="showExample"
    >
      <div slot="title" class="custom_header">
        <span class="title">C端用户活动界面</span>
      </div>
      <img
        class="img"
        src="@/assets/images/白条-C端用户活动界面.png"
        alt=""
      />
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import create from "./components/createActivity.vue";
import { mapState } from "vuex";
import {
  getList,
  venderDetail,
  popSign,
  quit,
  checkSku,
  appendSKU,
  getDetail,
  createActivity,
  exportFailSKU,
  exportSKU,
} from "@/api/iou";

export default {
  components: {
    inputForm,
    create,
  },

  computed: {
    ...mapState(["venderType"]),
  },

  data() {
    return {
      formData: {
        actBaseName: "",
        refActId: "",
        startTime: "",
        finishTime: "",
        baseStatus: "",
      },
      pagination: {
        current: 1,
        size: 10,
      },
      total: 0,
      showExample: false, // 示例图
      showDetail: false, // 活动详情
      showCloseActivity: false, // 关闭活动弹窗
      dialogSKu: false, // 添加sku
      checked: false, // 是否同意pop协议内容
      isAdmittance: false, // 是否准入
      isSign: false, // 是否签署
      activeName: "first",
      createStep: 1, // 步骤，1：活动管理，2：创建活动
      inputData: [
      {
          name: "活动编号:",
          val: "refActId",
          placeholder: "请输入活动编号",
          width: "150px",
        },
        {
          name: "活动名称:",
          val: "actBaseName",
          placeholder: "请输入活动名称",
          width: "150px",
        },
        {
          name: "活动状态:",
          val: "virtualState",
          placeholder: "请选择",
          width: "150px",
          selectArr: [
            { label: "全部", id: 8, defaultValue: 8 },
            { label: "未开始", id: 4 },
            { label: "进行中", id: 5 },
            { label: "即将到期", id: 7 },
            { label: "已结束", id: 6 },
          ],
        },
        {
          name: "活动时间:",
          myDate: true,
          val: ["startTime", "finishTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      talbeLoading: false,
      activityList: [], // 活动列表
      activityDetail: {}, // 活动详情
      operateId: "", // 当前操作的活动编号
      operateObj: {}, // 当前操作的活动对象
      uploadData: {}, // 文件上传集合
      admittanceInfo: {}, // 准入信息
    };
  },

  filters: {
    baseStatusFilter(status) {
      if (status == 0) {
        return "未开始"
      } else if (status == 1) {
        return "进行中"
      } else if (status == 2) {
        return "已结束"
      } else if (status == 3) {
        return "即将到期"
      } else {
        return "-"
      }
    },
    
    boundFilter(type) {
      if (type == 1) {
        return "全店参与"
      } else if (type == 2) {
        return "部分商品参与"
      } else if (type == 3) {
        return "部分商品不参与"
      } else {
        return "-"
      }
    },

    planNumFilter(str) {
      if (str) {
        const arr = str.split(",")
        let strName = ""
        arr.map((item) => {
          strName = strName + item + "期、"
        })
        return strName.slice(0, -1)
      }
    },
  },

  created() {
    this.venderDetail()
  },

  methods: {
    showPDF(){
      window.open("https://www.yuque.com/yunduanxincrm/flgan6/knfm4v2ipguf8yg3?singleDoc#")
    },
    showDetailClose() {
      this.activityDetail = {}
    },

    // 导出详情sku
    exportDetailSku(obj) {
      let elm = document.createElement("a");
      elm.style.display = 'none';
      let url = '/jd-hd-web/iou/exportSku/' + obj.mktActBaseNo;
      elm.href = url;
      document.body.appendChild(elm);
      elm.click();
      document.body.removeChild(elm);
    },

    downloadTemplate() {
      let url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/sku%E4%B8%8A%E4%BC%A0%E6%A8%A1%E7%89%88.xlsx";
      let fileName= "sku上传模版.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },


    closeAddSku() {
      this.uploadData = {}
      this.$refs.uploadFile.clearFiles()
    },

    // 准入信息
    venderDetail() {
      venderDetail().then((res) => {
        console.log('res------>', res)
        if (res.code != 1) {
          return this.$message.error(res.message)
        }
        this.admittanceInfo = res.data || {}
        if (this.checkViewCondition()) return
        this.getList()
      })
    },

    // 页面判断校验
    checkViewCondition() {
      // 判断准入条件
      if (!this.admittanceInfo.isAccess) {
        this.isAdmittance = true
        return true
      }
      // 判断是否签约
      if (!this.admittanceInfo.isSigned) {
        this.isSign = true
        return true
      }
      return false
    },

    // 分页查询事件
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },

    // 获取活动列表
    getList() {
      this.talbeLoading = true
      const params = {
        ...this.formData,
        ...this.pagination,
      }
      getList(params).then((res) => {
        this.talbeLoading = false
        this.activityList = res.data.records || []
        this.total = Number(res.data.total) || 0
        this.pagination.current = Number(res.data.current) || 1
      })
    },

    // 确认关闭活动
    submitClose() {
      quit(this.operateId).then((res) => {
        this.showCloseActivity = false
        if (res.code == 1) {
          this.$message.success("关闭成功")
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    submitFn() {
      this.createStep = 1
      this.getList()
    },

    // 关闭活动
    closeFn(row) {
      this.operateId = row.mktActBaseNo
      this.showCloseActivity = true
    },

    // 活动详情
    detailFn(row) {
      this.showDetail = true
      getDetail(row.mktActBaseNo).then((res) => {
        this.activityDetail = res.data
      })
    },

    // 添加sku商品
    addSku(row) {
      this.operateId = row.mktActBaseNo
      this.operateObj = row
      this.dialogSKu = true
    },

    // 确认上传sku
    submitUpload() {
      if (!this.uploadData.total) {
        return this.$message.error("请上传文件")
      }
      const params = {
        skuIds: this.uploadData.passSkus,
        mktActBaseNo: this.operateObj.mktActBaseNo,
        refActId: this.operateObj.refActId,
        finishTime: this.operateObj.finishTime,
      }
      appendSKU(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("添加成功")
          this.dialogSKu = false
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleRemove(files, fileList) {
      this.uploadData = {}
    },

    handleExceed(files, fileList) {
      this.$message.error(`当前限制选择1个文件`);
    },

    handleSuccess(res) {
      if (res.code != 1) {
        this.$refs.uploadFile.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.uploadData = res.data
    },

    // 下载错误sku信息
    uploadError() {
      exportFailSKU({ errorSkus: this.uploadData.errorSkus }).then((res) => {
        this.successMsg = "";
        this.dialogExprot = false;
        let Time = new Date().toLocaleString();
        let blob = new Blob([res.blob]);
        let link = document.createElement("a"); //a标签下载
        link.href = window.URL.createObjectURL(blob);
        link.download = "导入失败sku_" + Time + ".xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
      })
    },

    // sku文件上传大小判断
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 2;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 2MB!");
        return  false;
      }
    },

    // 自营去签约
    goSign() {
      this.isSign = false
    },

    // pop确认签署
    submitSign() {
      if (!this.checked) {
        return this.$message.warning("请认真阅读协议并同意勾选")
      }
      popSign().then((res) => {
        if (res.code == 1) {
          this.isSign = false
          this.$message.success("签约成功")
          this.venderDetail()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 点击创建活动
    createIou() {
      if (this.checkViewCondition()) return
      this.createStep = 2
    },
    
    // 跳转白条账单
    openIouBill() {
      if (this.checkViewCondition()) return
      if (this.venderType) {
        window.open("https://pro.jd.com/mall/active/3rs7mHbBTMX5STeiU8e3W1y15Prp/index.html", "_blank",)
      } else {
        window.open("https://shop.jd.com/jdm/fin/detailAccount/BaitiaoAccount", "_blank",)
      }
    },

    // 跳转白条数据看板
    openIouData() {
      if (this.checkViewCondition()) return
      window.open("https://jmw.jd.com/pc/accountIntercept/", "_blank",)
    },

    // 跳转pop协议
    popAgreement() {
      this.isSign = false
      window.open(this.admittanceInfo.agreementUrl, "_blank",)
    },

    // 查询
    searchForm(form) {
      this.formData = form
      if (this.checkViewCondition()) return
      this.getList()
    },
  },
};
</script>

<style lang="scss" scoped>
.activeType {
  margin: 24px;
  padding: 24px;
  background: #ffffff;
  padding-bottom: 0;
  color: #333;

  .top_container {
    display: flex;

    .img_box {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      -webkit-box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;

      img {
        width: 93%;
        top: 50%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .content_box {
      position: relative;
      margin-left: 32px;
      margin-top: 16px;
      flex: 1;

      .title {
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }

      .content {
        margin: 12px 0 16px; 
        color: #666666;
        line-height: 16px;

        .url {
          color: #7B61FF;
          text-decoration: none;
          margin-right: 8px;
        }
      }

      .tips_box {
        padding: 12px 15px; 
        border-radius: 4px;
        color: #666666;

        .title {
          font-size: 13px;
          color: #333;
          display: flex;
          align-items: center;

          img {
            display: inline-block;
            float: left;
            width: 12px;
            height: 12px;
            color: #ffffff;
            margin-right: 6px;
          }
        }

        p {
          line-height: 20px;
        }
      }

      .bottom_box {
        margin-top: 30px;
        display: flex;
        align-items: center;

        button {
          min-width: 122px;
          height: 32px;
          line-height: 28px;
          background-color: white;
          outline: none;
          cursor: pointer;
          text-align: center;
          transition: all 0.2s;
          border-radius: 4px;
          background-color: rgba(123, 97, 255, 0.1);
          border: none;
        }

        .b1 {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 138px;
          color: #fff;
          margin-bottom: 20px;
          background-color: #7b61ff;
          &:hover {
            opacity: 0.9;
          }
        }
        .b2 {
          margin: 0 12px 20px 12px;
        }
        .b2,
        .b3 {
          border: 1px solid #7b61ff;
          color: #7b61ff;
          margin-bottom: 20px;
          &:hover {
            background-color: #7b61ff;
            color: #fff;
          }
        }
      }
    }
  }

  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #E4E7ED;
    z-index: 1;
  }

  .editList {
    .pointer {
      cursor: pointer;
      color: #7b61ff;
      margin-right: 12px;
    }
  }
}

.activity_detail {
  .title {
    transform: translateY(-14px);
    color: #000;
    font-weight: bold;
    font-size: 15px;
  }

  .item, .download {
    line-height: 24px;
  }

  .download {
    text-decoration: underline;
    color: #7b61ff;
    cursor: pointer;
  }
}

.isSign_box {
  .pop_header {
    position: relative;
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    line-height: 56px;
    padding-left: 20px;

    &:after {
      position: absolute;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: #f2f2f2;
      width: 100%;
      content: "";
    }
  }

  .zy_header {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    line-height: 80px;
    padding-left: 20px;
  }

  .content_box {
    padding: 0 20px;
  }

  .custom_checkbox {
    margin-right: 30px;
    margin-left: 10px;
  }

  .tips_title {
    margin-top: 20px;
    margin-bottom: 10px;
    color: #000;
    font-weight: bold;
  }

  .tips_text {
    line-height: 20px;

    span {
      color: red;
    }

    .font {
      cursor: pointer;
      color: #7b61ff
    }

    &:last-child {
      margin-bottom: 40px;
    }
  }

  /deep/ .el-dialog .el-dialog__header {
    height: 0;
    padding: 0;
    line-height: 52px;
    font-size: 16px;
    background-color: #FFF;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom: none;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }

  /deep/ .el-dialog .el-dialog__body {
    background-color: #fff;
    border-radius: 6px;
  }

  /deep/ .el-dialog__footer {
    padding: 20px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-top: 1px solid #f2f2f2;
  }
}

.pagination {
  margin: 20px 0;
  text-align: right;
}

.sku_box {
  .download {
    min-width: 100px;
    height: 32px;
    line-height: 30px;
    background-color: white;
    outline: none;
    cursor: pointer;
    text-align: center;
    transition: all 0.2s;
    border-radius: 3px;
    border: none;
    border: 1px solid #7b61ff;
    color: #7b61ff;
    margin: 20px 0;
    
    &:hover {
      background-color: #7b61ff;
      color: #fff;
    }
  }

  .checkout {
    transform: translateY(-20px);
    color: #71c647;

    .success, .error {
      color: red;
    }

    .dowload_error {
      color: #7b61ff;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  /deep/.el-dialog__footer {
    padding: 20px;
    padding-top: 10px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}

.status1 {
  display: inline-block;
  padding: 1px 12px;
  background-color: #FEF1EC;
  color: #F36F39;
  border-radius: 13px;
}

.status2 {
  display: inline-block;
  padding: 1px 12px;
  background-color: #F1F1F1;
  color: #5B5B5B;
  border-radius: 13px;
}

.status3 {
  display: inline-block;
  padding: 1px 12px;
  background-color: #FFE8ED;
  color: #FB4065;
  border-radius: 13px;
}

.status0 {
  display: inline-block;
  padding: 1px 12px;
  background-color: #E6F7FF;
  color: #02B1FF;
  border-radius: 13px;
}

.showExample {
  text-align: center;

  .custom_header {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: bold;
  }

  .img {
    width: 886px;
    height: 640px;
  }

  /deep/ .el-dialog .el-dialog__header {
    height: 52px;
    padding: 0px 32px 0px;
    line-height: 52px;
    font-size: 16px;
    background-color: #FFF;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom: none !important;
  }

  /deep/ .el-dialog__body {
    padding: 0 0 20px 0; 
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}
</style>
